import { defineMessages } from 'react-intl';

// Keyed by the wire value of `SimpleCitation.retrieved_from` (MOD-1726).
export const retrievedFromMessages = defineMessages({
  library: {
    id: '2IpyfI4nn/',
    defaultMessage: 'Local library',
    description:
      'Provenance label on an Evidence source retrieved from the reference library installed on an on-premises appliance. Not the My Library documents a user uploads',
  },
  journal_repo: {
    id: 'QVrYfUFPZh',
    defaultMessage: 'Local journals',
    description:
      'Provenance label on an Evidence source retrieved from the journal archive installed on an on-premises appliance',
  },
  web: {
    id: 'JMSYAqaWyh',
    defaultMessage: 'Web',
    description:
      'Provenance label on an Evidence source retrieved by web search, shown only when the same answer also cites locally installed sources',
  },
});
